import _ from 'lodash';
import React from 'react';
import moment from 'moment';
import uuid4 from 'uuid/v4';

import {DATE_FORMAT_API} from 'utils/datetime';

import {RESOLUTION_OPTIONS, TOTAL} from 'ducks/occupancy';

import './styles.css';

const BAR_MAX_HEIGHT = 200; // in px
class BarColoredSegment extends React.Component<any> {
  render() {
    const {barHeight, type, tooltipData} = this.props;

    const typeCSSClassString = type.split(' ').join('-');

    return (
      <React.Fragment>
        <div
          className={`ChartBar__segment ChartBar__segment--${typeCSSClassString ||
            'unknown'}`}
          style={{
            height: barHeight * BAR_MAX_HEIGHT
          }}
          data-tip={JSON.stringify(tooltipData)}
          data-for="ChartBar__tooltip"
        />
      </React.Fragment>
    );
  }
}

const ChartBar = ({segments, tableColumn, totalOccupancy, unitsRenderer}) => {
  const percentage = barSlug =>
    tableColumn.barValues[barSlug].value /
    tableColumn.barValues[barSlug].maxValue;

  const calcBarHeight = barSlug =>
    percentage(barSlug) *
    (tableColumn.barValues[barSlug].maxValue / totalOccupancy);

  return (
    <div className="ChartBar">
      {segments.map(({value}) => (
        <BarColoredSegment
          key={value}
          barHeight={calcBarHeight(value)}
          type={value}
          unitsRenderer={unitsRenderer}
          tooltipData={tableColumn.barValues[value].tooltipData}
        />
      ))}
    </div>
  );
};

class TableCell extends React.Component<any> {
  state = {id: uuid4()};

  render() {
    const {className, value, maxValue, tooltipData, unitsRenderer} = this.props;

    return (
      <React.Fragment>
        <div
          className={className}
          data-tip={JSON.stringify(tooltipData)}
          data-for="ChartBar__tooltip"
          data-delay-show={1000}>
          {unitsRenderer(value, maxValue)}
        </div>
      </React.Fragment>
    );
  }
}

const TableTotalCell = ({value, unitsRenderer}) => {
  return (
    <TableCell
      className="ChartColumn__table__total ChartColumn__table__row ChartColumn__table__row--with-shadow colab-centered"
      value={value.value}
      maxValue={value.displayValue}
      tooltipData={value.tooltipData}
      unitsRenderer={unitsRenderer}
    />
  );
};

const TableRegularCell = ({value, unitsRenderer}) => {
  return (
    <TableCell
      className="ChartColumn__table__row colab-centered"
      value={value.value}
      maxValue={value.maxValue}
      tooltipData={value.tooltipData}
      unitsRenderer={unitsRenderer}
    />
  );
};

const TableCollapsibleRowCell = ({value, unitsRenderer}) => {
  return (
    <TableCell
      className="ChartColumn__table__row ChartColumn__table__row--with-shadow colab-centered"
      value={value.value}
      maxValue={value.displayValue}
      tooltipData={value.tooltipData}
      unitsRenderer={unitsRenderer}
    />
  );
};

const TableGroupColumn = (
  {groupData, group, openedGroups, unitsRenderer} // TODO if openedRoomTypeGroups doesnt contain RoomTypeGroup.value -> add with shadow to the `group` not the `row`
) => (
  <div className="ChartColumn__table__group">
    <TableCollapsibleRowCell
      value={groupData.groupValue}
      unitsRenderer={unitsRenderer}
    />
    {_.find(openedGroups, x => x === group.value) && (
      <div className="roomTypeGroup__roomTypes">
        {group.nestedElements &&
          group.nestedElements.map(nestedElement => (
            <TableRegularCell
              key={nestedElement.value}
              value={groupData.nestedElements[nestedElement.value]}
              unitsRenderer={unitsRenderer}
            />
          ))}
      </div>
    )}
  </div>
);

const ChartColumnLabel = ({date, resolution}) => {
  let label: string = '';
  let subLabel: string = '';

  if (resolution === RESOLUTION_OPTIONS.DAILY) {
    label = date.format('ddd'); // Mon, Thu, ... Sun
    subLabel = date.format('DD/MM/YY');
  }

  if (resolution === RESOLUTION_OPTIONS.WEEKLY) {
    label = date.format('MMM'); // Jan, Feb, ... Dec
    subLabel = date.format('DD/MM/YY');
  }

  if (resolution === RESOLUTION_OPTIONS.MONTHLY) {
    label = date.format('MMM'); // Jan, Feb, ... Dec
    subLabel = moment(date, DATE_FORMAT_API)
      .year()
      .toString();
  }

  return (
    <div className="ChartColumn__label">
      <div className="colab-bold">{label}</div>
      <p>{subLabel}</p>
    </div>
  );
};

const ChartColumn = ({
  tableColumn,
  tableHeaders,
  unitsRenderer,
  resolution,
  segments,
  openedNestedGroups
}) => (
  <div className="ChartColumn">
    <div className="ChartColumn__bar">
      <ChartBar
        totalOccupancy={tableColumn.tableData[TOTAL].displayValue}
        segments={segments}
        tableColumn={tableColumn}
        unitsRenderer={unitsRenderer}
      />
    </div>
    <ChartColumnLabel date={tableColumn.date} resolution={resolution} />
    <div className="ChartColumn__table">
      <TableTotalCell
        value={tableColumn.tableData[TOTAL]}
        unitsRenderer={unitsRenderer}
      />
      {tableHeaders.map(group => (
        <TableGroupColumn
          key={group.value}
          group={group}
          groupData={tableColumn.tableData[group.value]}
          unitsRenderer={unitsRenderer}
          openedGroups={openedNestedGroups}
        />
      ))}
    </div>
  </div>
);

export default ChartColumn;
